import { QueryStatus } from '@reduxjs/toolkit/query';
import clsx from 'clsx';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback, useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';

import { useSaveWorkspace } from '@/store/workspace/useSaveWorkspace.ts';

type ButtonVariant = 'active' | 'success';

export function SaveWorkspaceButton() {
  const { saveWorkspace, status, isLoading } = useSaveWorkspace();
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const [variant, setVariant] = useState<ButtonVariant>('active');

  const buttonIcon = variant === 'success' ? 'check_circle' : 'save';
  const isButtonDisabled = variant !== 'active';

  const handleSaveWorkspace = () => {
    sgwtWebAnalytics?.trackEvent('Workspace', 'Save workspace');
    saveWorkspace();
  };

  const onSuccess = useCallback(() => {
    setVariant('success');
    setTimeout(() => setVariant('active'), 1500);
  }, []);

  const onError = useCallback(() => {
    // TODO: better error managment
    setVariant('active');
  }, []);

  useEffect(() => {
    if (status === QueryStatus.fulfilled) {
      onSuccess();
    }
    if (status === QueryStatus.rejected) {
      onError();
    }
  }, [status, onError, onSuccess]);

  return (
    <Button variant="flat-primary" className="btn-lg btn-icon" onClick={handleSaveWorkspace} disabled={isButtonDisabled}>
      <i
        data-e2e="save-workspace-btn"
        className={clsx('icon', { invisible: isLoading, 'text-success': variant === 'success' })}
      >
        {buttonIcon}
      </i>
      {isLoading ? <Spinner size="sm" className="position-absolute" /> : null}
    </Button>
  );
}
